// src/components/StationCardItem.jsx
import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Link,
  Stack,
  Box,
  CircularProgress,
} from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";

//  1. Accept currentFilter as a prop
export default function StationCardItem({ station, filteredStations, currentFilter }) {
  const [imgLoaded, setImgLoaded] = useState(false);

  // Map URL Logic
  let googleMapsUrl = "#";
  if (station.lat && station.lon) {
    googleMapsUrl = `https://www.google.com/maps?q=${station.lat},${station.lon}`;
  } else if (station.location) {
    googleMapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(station.location)}`;
  }

  const displayImage = station.thumbnail || station.mainImg;

  return (
    <Card
      sx={{
        boxShadow: 5,
        overflow: "hidden",
        maxWidth: 350,
        minHeight: 500,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        borderRadius: 1,
      }}
    >
      {/* --- IMAGE CONTAINER WITH FADE EFFECT --- */}
      <Box sx={{ position: "relative", height: 350, backgroundColor: "#f5f5f5" }}>
        {/* 1. SPINNER */}
        {!imgLoaded && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1,
            }}
          >
            <CircularProgress size={30} sx={{ color: "#009fb6" }} />
          </Box>
        )}
        {/* 2. ACTUAL IMAGE */}
        <CardMedia
          component="img"
          image={displayImage}
          alt={station.location}
          onLoad={() => setImgLoaded(true)}
          sx={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
            position: "relative",
            zIndex: 2,
            opacity: imgLoaded ? 1 : 0, 
            transition: "opacity 0.8s ease-in-out", 
          }}
        />
      </Box>
      {/* --- CARD CONTENT --- */}
      <div style={{ height: "3px", backgroundColor: "#d1d1d1", width: "100%" }}></div>

      <CardContent sx={{ display: "flex", flexDirection: "column", flexGrow: 1, py: 2, px: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
         <Typography fontWeight={500} sx={{ fontSize: "1.6rem", lineHeight: 1.1, minHeight: '46px', dislay: 'flex', alignItems: "flex-start" }}>
          {station.location}
        </Typography>

        {station.province && (
          <Typography
            variant="subtitle1"
            sx={{
              color: "#009fb6",
              fontWeight: 700,
              mt: 1,
              fontSize: "1.1rem",
              textTransform: "uppercase",
            }}
          >
            {station.province}
          </Typography>
        )}
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
          <Link
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
              color: "#a4cc40",
              fontWeight: 600,
              fontSize: "1.25em",
              display: "flex",
              alignItems: "center",
              letterSpacing: 1,
            }}
          >
            <RoomIcon sx={{ fontSize: 15, mr: 0.4, verticalAlign: "middle" }} />
            VIEW IN MAP
          </Link>
          <Link
            component={RouterLink}
            to="/stations/station_details"
            state={{
              currentStation: station,
              station: station,
              allStations: filteredStations,
              currentFilter: currentFilter || "All"
            }}
            underline="none"
            sx={{
              color: "#00aeef",
              fontWeight: 600,
              fontSize: "1.25em",
              display: "flex",
              alignItems: "center",
              letterSpacing: 1,
            }}
          >
            VIEW OPENING →
          </Link>
        </Stack>
      </CardContent>
    </Card>
  );
}